
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_4xftv_186",
  "arrow-outer": "awsui_arrow-outer_xjuzf_4xftv_190",
  "arrow-inner": "awsui_arrow-inner_xjuzf_4xftv_190",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_4xftv_221",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_4xftv_221",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_4xftv_224",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_4xftv_224",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_4xftv_227",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_4xftv_227",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_4xftv_227",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_4xftv_227",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_4xftv_230",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_4xftv_230",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_4xftv_230",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_4xftv_230",
  "body": "awsui_body_xjuzf_4xftv_326",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_4xftv_340",
  "has-dismiss": "awsui_has-dismiss_xjuzf_4xftv_344",
  "dismiss": "awsui_dismiss_xjuzf_4xftv_349",
  "dismiss-control": "awsui_dismiss-control_xjuzf_4xftv_356",
  "header-row": "awsui_header-row_xjuzf_4xftv_360",
  "header": "awsui_header_xjuzf_4xftv_360",
  "content": "awsui_content_xjuzf_4xftv_386",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_4xftv_393",
  "container": "awsui_container_xjuzf_4xftv_489",
  "container-body": "awsui_container-body_xjuzf_4xftv_497",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_4xftv_512",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_4xftv_517",
  "fixed-width": "awsui_fixed-width_xjuzf_4xftv_520",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_4xftv_524",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_4xftv_531",
  "container-arrow": "awsui_container-arrow_xjuzf_4xftv_543",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_4xftv_547",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_4xftv_547",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_4xftv_559",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_4xftv_559",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_4xftv_571",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_4xftv_571",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_4xftv_571",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_4xftv_571",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_4xftv_587",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_4xftv_591",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_4xftv_595",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_4xftv_1",
  "refresh": "awsui_refresh_xjuzf_4xftv_713",
  "root": "awsui_root_xjuzf_4xftv_735",
  "trigger": "awsui_trigger_xjuzf_4xftv_748",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_4xftv_755",
  "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_4xftv_784",
  "popover-content": "awsui_popover-content_xjuzf_4xftv_788"
};
  